import { collection, limit, onSnapshot, orderBy, query, type Timestamp } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { db } from './firebase';
import type { TxType } from './logTransaction';

interface TxRecord {
  type: TxType;
  hash: string;
  account: string;
  chainId: number;
  details: Record<string, string>;
  createdAt: Timestamp | null;
}

export interface ActivityItem {
  type: TxType;
  hash: string;
  pool?: string;
  amount?: string;
  at: number;
}

// Reuses the same global transactions stream as the dashboard (read: if true)
// and filters client-side to the connected wallet, so no composite index is
// needed for an account+time query.
export function useMyActivity(account: string | undefined, max = 8): ActivityItem[] | null {
  const [items, setItems] = useState<ActivityItem[] | null>(null);

  useEffect(() => {
    if (!account) {
      setItems([]);
      return;
    }
    const lower = account.toLowerCase();
    const q = query(collection(db, 'transactions'), orderBy('createdAt', 'desc'), limit(500));
    return onSnapshot(q, (snapshot) => {
      const mine: ActivityItem[] = [];
      for (const doc of snapshot.docs) {
        const tx = doc.data() as TxRecord;
        if (tx.account?.toLowerCase() !== lower) continue;
        mine.push({
          type: tx.type,
          hash: tx.hash,
          pool: tx.details?.pool,
          amount: tx.details?.amount,
          at: tx.createdAt?.toMillis() ?? 0,
        });
        if (mine.length >= max) break;
      }
      setItems(mine);
    });
  }, [account, max]);

  return items;
}
